import { defineStore } from 'pinia'

export const useInspectionDetailStore = defineStore('inspectionDetailStore', {
  state: () => ({
    detail: null
  })
})
